import consumer from './consumer';

let body = document.getElementsByTagName('body')[0];
let userId = body.dataset.userId;
let uniqueSessionId = body.dataset.uniqueSessionId;

const logoutChannel = consumer.subscriptions.create({channel: 'LogoutChannel', user_id: userId}, {
    connected() {
    },

    received(data) {
        data.unique_session_id !== uniqueSessionId && location.reload();
    }
});

export default logoutChannel;
